// Profit First settings: CAPs, the pay schedule, owner salary, buffer policy,
// and the Monday deposit log. Persisted in firm_settings under 'profitFirst'
// so they are editable in-app without a code change and shared across staff.

import { getFirmSetting, setFirmSetting } from '../../utils/firmSettings';

export const DEFAULT_SETTINGS = {
  caps: { profit: 10, owner: 20, tax: 5, opex: 65 }, // Profit First CAPs, % of each deposit
  ownerAnnualSalary: 100000, // owner's W-2 salary (funded from Owner's Comp, excluded from the Opex pool)
  schedule: {
    payrollDays: [15, 'last'], // 15th + last business day
    contractorDow: 5,          // Friday
    referralDay: 20,           // referral ACH from Opex
    cardDay: 7,                // card paid in full
  },
  bufferOverride: null,        // null = auto (one month of employee salary + expenses)
  depositLog: [],              // [{ date:'YYYY-MM-DD', amount, splits:{profit,owner,tax,opex} }]
};

// Deep-ish merge so a stored partial object still gets new default keys.
export function loadProfitFirstSettings() {
  const s = getFirmSetting('profitFirst', null) || {};
  return {
    ...DEFAULT_SETTINGS,
    ...s,
    caps: { ...DEFAULT_SETTINGS.caps, ...(s.caps || {}) },
    schedule: { ...DEFAULT_SETTINGS.schedule, ...(s.schedule || {}) },
    depositLog: Array.isArray(s.depositLog) ? s.depositLog : [],
  };
}

export function saveProfitFirstSettings(next) {
  setFirmSetting('profitFirst', next);
}

// Append a Monday allocation to the log (most recent first, capped at 52 weeks).
export function logDeposit(settings, amount, splits) {
  const entry = { date: new Date().toISOString().slice(0, 10), amount, splits };
  const depositLog = [entry, ...(settings.depositLog || [])].slice(0, 52);
  return { ...settings, depositLog };
}
